import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, FormControl, InputLabel, Input, Button, FormLabel, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import SearchSelect from "../components/searchAndSelect"
import { postBankUser, getBankUserDetails, putBankUser } from "../services/httpCalls"
import useNotify from "../utils/useNotify"
import { useLocation } from "react-router-dom"
import { cleanObject } from "../utils/onboarding/clean-object";

export default function AddBankUser() {
    const [bankUserId, setBankUserId] = useState()
    const [editFlag, setEditFlag] = useState()
    const [bankId, setBankId] = useState()
    const [bankUser, setBankUser] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        userStatus: 'ACTIVE',
        role: 'USER',
        userRoleList: []
    })
    let notify = useNotify()
    const routerPath = useLocation();
    const pathname = routerPath.pathname;
    const selectSearchData = (e) => {
        setBankId(e.id)
    }
    const submitBankUser = async (e) => {
        e.preventDefault()
        let data = bankUser;
        let cleanData = cleanObject(data);
        if (editFlag) {
            await putBankUser(cleanData, bankId, bankUserId)
                .then((res) => {
                    if (res) {
                        notify.success("Successfully updated Bank User!")
                    }
                })
                .catch((err) => {
                    if (err) {
                        notify.error("Not able to create Bank")
                    }
                })
        } else {
            if (!bankUser.name) {
                notify.error("Bank name is required field!")
                return false
            }
            if (bankUser.userRoleList.length === 0) {
                notify.error("Atleast one role need to be selected!")
                return false
            }
            await postBankUser(cleanData, bankId)
                .then(() => {
                    notify.success("Successfully added new bank user")
                    setBankUser({
                        name: '',
                        email: '',
                        phoneNumber: '',
                        userStatus: 'ACTIVE',
                        role: 'USER',
                        userRoleList: []
                    })
                })
                .catch(() => {
                    notify.error("Not able to add new bank user")
                })
        }
    }
    const handleChange = (e) => {
        let userRoles = bankUser.userRoleList
        if (e.checked) {
            userRoles.push(e.value)
        } else {
            let index_ = userRoles.indexOf(e.value)
            userRoles.splice(index_, 1)
        }
        setBankUser({ ...bankUser, userRoleList: userRoles })
    };
    useEffect(() => {
        const fetchData = async () => {
            let url_ = window.location.pathname;
            if (pathname === "/addbankuser") {
                setEditFlag(false);
                setBankUser({
                    name: '',
                    email: '',
                    phoneNumber: '',
                    userStatus: 'ACTIVE',
                    role: 'USER',
                    userRoleList: []
                });
            } else {
                await preFetchData(url_);
            }
        };
        fetchData();
    }, [pathname]);

    const preFetchData = async (url_) => {
        let bankId_ = url_.split("/")[2];
        let userId_ = url_.split("/")[3];
        setBankId(bankId_);
        setBankUserId(userId_);
        setEditFlag(true);
        if (!bankId_ && !userId_) {
            return false
        }
        await getBankUserDetails(bankId_, userId_)
            .then((res) => {
                setBankUser({
                    name: res.name,
                    email: res.email,
                    phoneNumber: res.phoneNumber,
                    userStatus: res.userStatus,
                    userRoleList: res.userRoles
                })
            })
    };
    return (
        <Box sx={{ padding: "1rem" }}>
            <Typography variant="h5" sx={{ paddingBottom: "1rem", fontWeight: 400 }}>{editFlag ? 'Edit Bank User' : 'Add Bank User'}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={6}>

                    <Box component="form" validate onSubmit={(e) => submitBankUser(e)}>
                        {
                            !editFlag &&
                            <SearchSelect selectSearchData={selectSearchData} label={"Select Bank"} name={"bankname"} />
                        }
                        <FormControl required variant="standard" sx={{ width: "300px", display: "block", marginTop: ".5rem" }}>
                            <InputLabel htmlFor="name">Name</InputLabel>
                            <Input id="name" sx={{ width: "100%" }}
                                required={true}
                                value={bankUser.name}
                                onChange={(e) =>
                                    setBankUser({
                                        ...bankUser,
                                        [e.target.id]: e.target.value,
                                    })
                                }
                            />
                        </FormControl>
                        <FormControl required variant="standard" sx={{ width: "300px", display: "block", marginTop: ".5rem" }}>
                            <InputLabel htmlFor="email">Email</InputLabel>
                            <Input id="email" type="email" sx={{ width: "100%" }}
                                required={true}
                                value={bankUser.email}
                                onChange={(e) =>
                                    setBankUser({
                                        ...bankUser,
                                        [e.target.id]: e.target.value,
                                    })
                                }
                            />
                        </FormControl>
                        <FormControl variant="standard" sx={{ width: "300px", display: "block", marginTop: ".5rem" }}>
                            <InputLabel htmlFor="phoneNumber">Phone Number</InputLabel>
                            <Input id="phoneNumber" type="number" sx={{ width: "100%" }}
                                value={bankUser.phoneNumber}
                                onChange={(e) =>
                                    setBankUser({
                                        ...bankUser,
                                        [e.target.id]: e.target.value,
                                    })
                                }
                            />
                        </FormControl>
                        <FormControl sx={{ mt: 4 }} component="fieldset" variant="standard">
                            <FormLabel component="legend">User Role List</FormLabel>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox value="BANK_ADMIN" onChange={(e) => handleChange(e.target)} checked={ bankUser.userRoleList.includes("BANK_ADMIN") ? true : false} />
                                    }
                                    value="BANK_ADMIN"
                                    label="Bank admin"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox value="BANK_OPS" onChange={(e) => handleChange(e.target)} checked={ bankUser.userRoleList.includes("BANK_OPS") ? true : false} />
                                    }
                                    value="BANK_OPS"
                                    label="Bank ops"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox value="KARBON_OPS" onChange={(e) => handleChange(e.target)} checked={ bankUser.userRoleList.includes("KARBON_OPS") ? true : false} />
                                    }
                                    value="KARBON_OPS"
                                    label="Karbon ops"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox value="BANK_MID_OFFICE" onChange={(e) => handleChange(e.target)} checked={ bankUser.userRoleList.includes("BANK_MID_OFFICE") ? true : false} />
                                    }
                                    value="BANK_MID_OFFICE"
                                    label="Bank mid office"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox value="BANK_PROCESSING" onChange={(e) => handleChange(e.target)} checked={ bankUser.userRoleList.includes("BANK_PROCESSING") ? true : false} />
                                    }
                                    value="BANK_PROCESSING"
                                    label="Bank processing"
                                />
                            </FormGroup>
                        </FormControl>

                        {/* <Checkbox.Group label={'User Role List'} name='userRoleList' rules={[{ required: true }]} options={roleList} defaultValue={['Apple']} onChange={onChange} /> */}

                        {/* <FormControl sx={{ paddingTop: "1rem" }}>
                            <FormLabel id="role" sx={{ fontSize: "12px" }}>Role</FormLabel>
                            <RadioGroup
                                id="role"
                                aria-labelledby="role"
                                sx={{ display: "flex", width: "300px", flexDirection: "row" }}
                                required={true}
                                value={bankUser.role}
                                onChange={(e) =>
                                    setBankUser({
                                        ...bankUser,
                                        ["role"]: e.target.value,
                                    })
                                }
                            >
                                <FormControlLabel
                                    value={"USER"} control={<Radio />} label="User" />
                                <FormControlLabel
                                    value={"ADMIN"} control={<Radio />} label="Admin" />
                            </RadioGroup>
                        </FormControl> */}
                        <Box>
                            <Button type="submit" variant={"contained"} sx={{ mt: "2rem", }}>{editFlag ? 'Edit Bank User' : 'Add Bank User'}</Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}